export default "../img/loading.svg";